
import DesignContentLayout from '@/layouts/design/DesignContentLayout';

export default {
  name: 'DesignComponentsReviewData',
  components: { DesignContentLayout }
};
